import React from "react";
import PropTypes from "prop-types";
import AnchorLink from "../AnchorLink";
import { HOME_URL } from "../../constants/route";
import { paramCase } from "change-case";

const propTypes = {
  title: PropTypes.string.isRequired,
  fromPage: PropTypes.string,
};

const Breadcrumb = ({ title, fromPage }) => {
  return (
    <section
      className={["breadcrumb-wrapper text-center", paramCase(title)].join(" ")}
    >
      <div className="container">
        <div className="breadcrumb-content">
          <h2>{title}</h2>
          <ul className="breadcrumb">
            <li>
              <AnchorLink href={HOME_URL}>Home</AnchorLink>
            </li>
            {fromPage !== "about_us" && fromPage !== "contact_us" && (
              <li>
                <AnchorLink href="#">Services</AnchorLink>
              </li>
            )}
            <li>{title}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

Breadcrumb.propTypes = propTypes;
export default Breadcrumb;
